import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { AddBankDetailComponent } from '../add-bank-detail/add-bank-detail.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-experience',
  templateUrl: './add-experience.component.html',
  styleUrls: ['./add-experience.component.scss']
})
export class AddExperienceComponent {
  public addForm!: FormGroup;
  public employeeId!: string;
  constructor(private fb: FormBuilder, private appService: AppService, private dialogRef: MatDialogRef<AddExperienceComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, private datePipe: DatePipe,
    private commonService: CommonService, private spinner: NgxSpinnerService, private recruiterService: RecruiterService,
  ) { }

  ngOnInit(): void {

    console.log(this.dialogData)
    this.addForm = this.fb.group({
      e_s: ["", Validators.required],
      pos: ["", Validators.required],
      st_dt: ["", Validators.required],
      ed_dt: ["", Validators.required],
      n_or: ["",],
      co_re: ["",],
      c_emp: ["", Validators.required],
      ref: ['']
    })


    if (this.dialogData) {
      this.employeeId = this.dialogData.em_i;

      if (this.dialogData.type === 'edit' && this.dialogData.data) {
        const data = this.dialogData.data;

        this.addForm.patchValue({
          e_s: data.e_s || "",
          pos: data.pos || "",
          st_dt: data.st_dt ? new Date(data.st_dt) : "",
          ed_dt: data.ed_dt ? new Date(data.ed_dt) : "",
          n_or: data.n_or || "",
          co_re: data.co_re || "",
          c_emp:  data.c_emp === 1 ? "yes" : "no",
          ref: data.ref // assuming 1 means true
        });
      }
    }

    // if(this.dialogData){
    //   this.employeeId=this.dialogData.em_i
    // }
    this.formValidation()
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onCancel() {
    this.dialogRef.close()
  }
  formValidation() {
    this.addForm.get('ref')?.valueChanges.subscribe((value) => {
      if (value == true) {
        this.addForm.get('n_or')?.setValidators([Validators.required]);
        this.addForm.get('co_re')?.setValidators([Validators.required]);
      }
      else {
        this.addForm.get('n_or')?.clearValidators();
        this.addForm.get('co_re')?.clearValidators();
      }
      this.addForm.get('n_or')?.updateValueAndValidity();
      this.addForm.get('co_re')?.updateValueAndValidity();
    })
  }
  // onSubmit() {
  //   if (this.addForm.valid == false) {
  //     this.addForm.markAllAsTouched()
  //     return
  //   }
  //   let obj = this.addForm.value;
  //   obj["em_i"] = this.employeeId
  //   obj["st_dt"] = this.datePipe.transform(this.addForm.get("st_dt")?.value, 'yyyy-MM-dd'),
  //     obj["ed_dt"] = this.datePipe.transform(this.addForm.get("ed_dt")?.value, 'yyyy-MM-dd'),

  //     this.recruiterService.addExp(obj).subscribe({
  //       next: (success: any) => {
  //         //this.spinner.hide()
  //         this.appService.showToastMessage('success', success.msg);
  //         this.dialogRef.close({ data_added: true })
  //       },
  //       error: (error: any) => {
  //         this.commonService.handleError(error);
  //       },
  //     });
  // }


  onSubmit() {
    if (!this.addForm.valid) {
      this.addForm.markAllAsTouched();
      return;
    }
  
    const obj = {
      ...this.addForm.value,
      em_i: this.employeeId,
      ref: this.addForm.value.ref ? 1 : 0,
      st_dt: this.datePipe.transform(this.addForm.get("st_dt")?.value, 'yyyy-MM-dd'),
      ed_dt: this.datePipe.transform(this.addForm.get("ed_dt")?.value, 'yyyy-MM-dd'),
    };
  
    if (this.dialogData.type === 'edit') {
      obj["exp_i"] = this.dialogData.data.id; // include ID for update
      this.recruiterService.editExp(obj).subscribe({
        next: (success: any) => {
          this.appService.showToastMessage('success', success.msg);
          this.dialogRef.close({ data_added: true });
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    } else {
      this.recruiterService.addExp(obj).subscribe({
        next: (success: any) => {
          this.appService.showToastMessage('success', success.msg);
          this.dialogRef.close({ data_added: true });
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  
}
